import { render, staticRenderFns } from "./admin-table.vue?vue&type=template&id=70fa8fc6&scoped=true&"
import script from "./admin-table.vue?vue&type=script&lang=js&"
export * from "./admin-table.vue?vue&type=script&lang=js&"
import style0 from "./admin-table.vue?vue&type=style&index=0&id=70fa8fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa8fc6",
  null
  
)

export default component.exports